import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import type { SelfDescribingJson } from '@snowplow/browser-tracker'

import { getCookies } from 'lib/web/cookieUtils'
import type { SupportedLocale } from 'i18n/supportedLocales'
import { DEFAULT_LOCALE } from 'i18n/util/locale'
import { isSupportedLocale } from 'i18n/util/localeMatcher'

export function languageContext(): SelfDescribingJson {
  return comluxgroup.createLanguage_1_0_0({
    language: getLanguageFromCookies(),
  })
}

export function getLanguageFromCookies(): SupportedLocale {
  const language = getCookies().lang

  return isSupportedLocale(language) ? language : DEFAULT_LOCALE
}
